export default "__VITE_ASSET__D6XDbe0M__"